/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_CautionInputs */

const en_orders_review_caution = /** @type {(inputs: Orders_Review_CautionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caution`)
};

const es_orders_review_caution = /** @type {(inputs: Orders_Review_CautionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precaucion`)
};

/**
* | output |
* | --- |
* | "Caution" |
*
* @param {Orders_Review_CautionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_caution = /** @type {((inputs?: Orders_Review_CautionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_CautionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_caution(inputs)
	return es_orders_review_caution(inputs)
});